import { closingColon } from "./helpers.js";
import { StyleOperations } from "./styles.js";

export const ButtonOperations = {
  isTrue: (arg) => {
    // check if it's a button
    let matcher = /\bbt\b/g;
    return matcher.test(arg);
  },
  /**
   * When you detect an opening colon, use a stack to find it's closing semi colon
   * bt:
   */
  hasOpened: true,

  // FIXME: should account for the classname and the inline styles

  openingColon: (arg) => {
      arg = arg.replace(/\bbt\b/, "<button ").replace(":", "");
    return arg;
  },
};

export const runButtonOperations = (readLinesOriginal, readLines, errors) => {
  for (var i = 0; i < readLines.length; i++) {

    console.log('button ops ----------------------')
    let x = readLines[i];
    if (ButtonOperations.isTrue(x)) {
      console.log("Found button")
      closingColon(readLines,i,ButtonOperations,'</button>')
      readLines[i] = ButtonOperations.openingColon(x);
    } else {
    }
  }
  return readLines;
};
